/**
 * Esquemas de validación del login (zod + react-hook-form).
 *
 * Reglas alineadas con el backend:
 *  - Administrador: identificador = correo, más contraseña.
 *  - Operador: identificador = código numérico (la contraseña es el propio código).
 */

import { z } from 'zod';

export const adminLoginSchema = z.object({
  identity: z
    .string()
    .trim()
    .min(1, 'Ingresa tu correo electrónico.')
    .email('Ingresa un correo electrónico válido.'),
  password: z
    .string()
    .min(1, 'Ingresa tu contraseña.')
    .max(120, 'La contraseña es demasiado larga.'),
});

export const operatorLoginSchema = z.object({
  identity: z
    .string()
    .trim()
    .min(4, 'El código debe tener al menos 4 dígitos.')
    .max(20, 'El código es demasiado largo.')
    .regex(/^\d+$/, 'El código de acceso solo contiene números.'),
});

export type AdminLoginValues = z.infer<typeof adminLoginSchema>;
export type OperatorLoginValues = z.infer<typeof operatorLoginSchema>;
